// extracted by mini-css-extract-plugin
export default {"mapContainer":"TestMap_mapContainer__YQDhp","info":"TestMap_info__+Brx2"};